import useU2000AxiosAuthenticated from "../../axios/U2000UseAxiosAuthenticated";

const LOGICALUNIT_URL = "U2001";
const CHANGEPASWORD_URL = LOGICALUNIT_URL + "/changePassword";

type ChangePasswordFn = (newPassword: string, confirmPassword: string) => Promise<any>;

const useU2000ChangePassword = (): ChangePasswordFn => {
  const u2000AxiosAuthenticated = useU2000AxiosAuthenticated();

  const doChangePassword: ChangePasswordFn = async (newPassword, confirmPassword) => {
    try {
      return await u2000AxiosAuthenticated.post(CHANGEPASWORD_URL, JSON.stringify({ newPassword, confirmPassword }));
    } catch (error) {
      throw error;
    }
  };
  return doChangePassword;
};

export default useU2000ChangePassword;
